import React, { type ReactNode } from 'react';
import { NotFoundErrorPageAsync } from '@atlassian/jira-error-pages/src/async.tsx';
import { useOgTenantInfo } from '../controllers/index.tsx';
import { ConsolidatedStateLoading } from './loading/index.tsx';

interface ConsolidatedStateWrapperProps {
	children: ReactNode;
	loadingComponent?: ReactNode;
	errorComponent?: ReactNode;
}

export const ConsolidatedStateWrapper = ({
	children,
	loadingComponent = <ConsolidatedStateLoading />,
	errorComponent = <NotFoundErrorPageAsync />,
}: ConsolidatedStateWrapperProps) => {
	const { shouldUseJSM, loading, error } = useOgTenantInfo();

	if (loading) {
		return loadingComponent;
	}

	if (error || !shouldUseJSM) {
		return errorComponent;
	}

	return children;
};
